// src/pages/NotFound.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, ArrowLeft, Home } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto">
      <Card className="p-10 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-navy-50 flex items-center justify-center mb-6">
          <Compass className="h-8 w-8 text-navy-600" />
        </div>
        <p className="text-sm font-semibold text-navy-600">Page not found</p>
        <h1 className="mt-1 text-2xl font-bold text-ink-900">This page doesn't exist</h1>
        <p className="mt-3 text-ink-500">
          The page may have moved, or the link might be out of date. Use the menu on
          the left, or head back to your dashboard.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="secondary" leftIcon={<ArrowLeft className="h-4 w-4" />} onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button variant="primary" leftIcon={<Home className="h-4 w-4" />} onClick={() => navigate('/dashboard')}>
            Go to dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default NotFound;
